module.exports = {
  axisXTitle: {
    en: "Academic Year",
    zh: "學年",
  },
  axisYTitle: {
    en: "No. of Students",
    zh: "學生人數",
  },
  labels: [
    '2013/14',
    '2014/15',
    '2015/16',
    '2016/17',
    '2017/18',
  ],
  series: [
    [1594, 1568, 1532, 1576, 1600],
  ],
}
